/**
 * Пока идёт заставка, сеть простаивает: прогреваем HTTP-кэш тем, что
 * понадобится при старте уровня (модели, текстуры, звуки, геометрия уровня).
 * Ничего не разбираем и не грузим в GPU — только скачиваем, поэтому кадры
 * заставки не проседают, а «Загрузка…» после нажатия PLAY идёт из кэша.
 */

async function drain(url: string): Promise<void> {
  try {
    const init: RequestInit & { priority?: string } = { credentials: "include", priority: "low" };
    const r = await fetch(url, init);
    if (!r.ok || !r.body) return;
    // читаем поток до конца и выбрасываем: в кэш попадает ответ целиком,
    // а в памяти не держим десятки мегабайт
    const reader = r.body.getReader();
    for (;;) {
      const { done } = await reader.read();
      if (done) break;
    }
  } catch {
    /* сеть — не страшно, игра скачает сама */
  }
}

/** Скачать список адресов по 2 одновременно. */
export async function warmHttpCache(urls: string[], parallel = 2): Promise<void> {
  const queue = [...new Set(urls)];
  const worker = async (): Promise<void> => {
    for (;;) {
      const u = queue.shift();
      if (!u) return;
      await drain(u);
    }
  };
  await Promise.all(Array.from({ length: Math.max(1, parallel) }, worker));
}

/** Статик-меш уровня (крупный GLB) — по манифесту, как это делает игра. */
export async function warmLevel(sceneId: string | undefined): Promise<void> {
  if (!sceneId || sceneId === "arena1") return;
  const conn = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection;
  if (conn?.saveData) return; // режим экономии трафика — не качаем десятки МБ впрок
  try {
    const r = await fetch(`${location.origin}/api/level-manifest?scene=${encodeURIComponent(sceneId)}`, { credentials: "include" });
    if (!r.ok) return;
    const j = (await r.json()) as { static_meshes?: string; terrain_collider?: string };
    const files = [j.terrain_collider, j.static_meshes].filter((f): f is string => typeof f === "string" && !!f);
    await warmHttpCache(
      files.map((f) => `${location.origin}/api/level-asset?scene=${encodeURIComponent(sceneId)}&file=${encodeURIComponent(f)}`),
      1,
    );
  } catch {
    /* ignore */
  }
}
